module.exports = __webpack_public_path__ + "img/help_dataset_overview.035429a6.png";